<template>
<section class="page-home">
  <div class="qbk-home-banner">
    <b-carousel id="qbk-home-banner" :interval="4000" controls fade>
      <!-- Slides with custom text -->
      <b-carousel-slide v-for="(car,carIndex) in carousel" :key="`car-${carIndex}`">
        <template v-slot:img>
          <img class="d-block img-fluid w-100" :src="car.image" alt="Qubika Hotel">
        </template>
        <div class="qbk-banner-caption qbk-wrap">
          <h1 class="animated slideInDown">{{car.title}}</h1>
          <p class="animated slideInRight">{{car.content}}</p>
          <a :href="(car.child[0].content) ? car.child[0].content : '#'" class="animated slideInUp" v-show="car.child[0].content">
            {{car.child[0].title}} <img src="../assets/images/bed.svg" alt="">
          </a>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </div>
  <div class="qbk-home-book-form">
    <div class="qbk-wrap">
      <div class="row">
        <div class="col-12 col-md-4 mb-2 mb-sm-0">
          <label class="book">Check In</label>
          <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="id" v-model="date.in"/>
        </div>
        <div class="col-12 col-md-4 mb-4 mb-sm-0">
          <label class="book">Check Out</label>
          <b-form-datepicker :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="id" v-model="date.out"/>
        </div>
        <div class="col-12 col-md-4">
          <a :href="`https://www.e1-booking.com/booking/booking-page.php?id=1526&checkin=${date.in}&checkout=${date.out}`" target="_blank">
            <button type="button" class="book">Check Availability</button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-home-welcome">
    <div class="qbk-wrap">
      <div class="row">
        <div class="col-12 col-md-6">
          <img :src="(welcome.image) ? welcome.image : '../assets/images/welcome.svg'" alt="" class="img-fluid w-100">
        </div>
        <div class="col-12 col-md-6">
          <h1>{{welcome.title}}</h1>
          <div v-html="welcome.content"></div>
          <a :href="(welcome.child) ? welcome.child[0].content : '#'" target="_blank">{{(welcome.child) ? welcome.child[0].title : '-'}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-home-hotels">
    <div class="qbk-wrap">
      <h1>Our Rooms</h1>
      <p>We have 133 rooms with 4 different types and sizes, it can be one of your choices. Each room is equipped with a modern design and complete facilities.</p>
      <div class="qbk-hh-wrap d-flex justify-content-between row no-gutters">
        <div class="qbk-hh-item col-12 col-sm-4 px-1 mb-2 mb-sm-0 my-3" v-for="(x,index) in room" :key="'qbk-hooper-'+index">
          <img :src="x.image" alt="Hotel" class="img-fluid w-100">
          <div class="qbk-hhi-content">
            <h2>{{x.title}}</h2>
            <div v-html="x.content" class="qbk-hhi-desc"></div>
            <!-- <ul>
              <li v-for="(xd,xdIndex) in x.details" :key="`xd-${xdIndex}`"><span>{{xd.title}}:</span> {{xd.content}}</li>
            </ul> -->
            <div class="qbk-hhi-nav flex-column">
              <!-- <label class="mb-3">
                From Rp. {{thousand(x.price)}} / night
              </label> -->
              <router-link :to="`/room/${x.id}`">
                View Details >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-home-info">
    <div class="qbk-wrap">
      <div class="row">
        <div class="col-12 col-md-6 qbk-hotel-testi">
          <h1>What They Said</h1>
          <hooper :settings="hooperSetTesti">
            <slide v-for="(x,index) in testi" :key="'qbk-hooper-info-'+index">
              <div class="qbk-hi-item">
                <img :src="x.image" alt="Visitor">
                <div class="qbk-hii-content">
                  <img src="../assets/images/quote.svg" alt="">
                  <p>{{x.content}}</p>
                  <h6>{{x.title}}</h6>
                </div>
              </div>
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
            <hooper-pagination slot="hooper-addons"></hooper-pagination>
          </hooper>
        </div>
        <div class="col-12 col-md-6 qbk-hotel-information">
          <h1>Hotel Information</h1>
          <ul>
            <li v-for="(n,index) in hotelInfo" :key="'qbk-collapse-info-'+index">
              <h4 v-b-toggle="'qbk-collapse-'+index">
                <small><img src="../assets/images/plus.svg"></small>
                {{n.title}}
              </h4>
              <b-collapse :id="'qbk-collapse-'+index" class="qbk-ci-content" visible>
                <p v-html="n.content"></p>
              </b-collapse>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-home-online-book">
    <div class="qbk-wrap">
      <h1>Book online today and look forward for<br>relaxing staycation with us.</h1>
      <p>Call us on <a href="tel:+622122970888">(021) 2297 0888</a>/ <a href="tel:+6282246457423">0822 4645 7423</a> or E-mail to <a href="mailto:reservation@qubikahotel.com">reservation@qubikahotel.com</a></p>
      <router-link to="/book">Online Booking ></router-link>
    </div>
  </div>
  <div class="qbk-home-news">
    <div class="qbk-wrap">
      <h1>Latest News</h1>
      <hooper :settings="hooperSetNews">
        <slide v-for="(x,index) in journal" :key="'qbk-hooper-article-'+index">
          <div class="qbk-hn-item">
            <router-link :to="`/journal/${x.id}`">
              <img :src="x.image" alt="Hotel" class="img-fluid w-100">
              <div class="qbk-hn-content">
                <h2>{{x.title}}</h2>
                <label>
                  <img src="../assets/images/calendar-alt.svg" alt=""> {{x.date}}
                </label>
                <p>{{limitWord(x.content,100)}}...</p>
                <span>Read More</span>
              </div>
            </router-link>
          </div>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
        <hooper-pagination slot="hooper-addons"></hooper-pagination>
      </hooper>
    </div>
  </div>
  <b-modal id="modal-promo" hide-header hide-footer centered size="lg">
    <b-carousel id="qbk-home-banner" :interval="4000" controls fade>
      <!-- Slides with custom text -->
      <b-carousel-slide v-for="(car,carIndex) in promo" :key="`car-${carIndex}`">
        <template v-slot:img>
          <router-link :to="`/promo/${car.id}`">
          <img class="d-block img-fluid w-100" :src="car.image" alt="Qubika Hotel">
          </router-link>
        </template>
        <!-- <router-link :to="`/promo/${car.id}`">
          <div class="qbk-banner-caption qbk-wrap">
            <h1 class="animated slideInDown">{{car.title}}</h1>
            <p class="animated slideInRight" v-html="car.content">{{car.content}}</p>
          </div>
        </router-link> -->
      </b-carousel-slide>
    </b-carousel>
  </b-modal>
</section>
</template>
<script>
import axios from 'axios'
import {baseUrl} from '../config'
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from 'hooper';
export default {
  name: 'home',
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 4,
        itemsToSlide: 4,
        infiniteScroll: false,
        autoPlay: false,
        playSpeed: 5000,
        breakpoints: {
          0: {
            itemsToSlide: 1,
            itemsToShow: 2
          },
          800: {
            itemsToSlide: 4,
            itemsToShow: 4
          },
          1000: {
            itemsToSlide: 4,
            itemsToShow: 4
          }
        }
      },
      hooperSetTesti: {
        itemsToShow: 1,
        itemsToSlide: 1,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 5000
      },
      hooperPromo: {
        itemsToShow: 1,
        itemsToSlide: 1,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 5000
      },
      hooperSetNews: {
        itemsToShow: 4,
        itemsToSlide: 1,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 5000,
        centerMode: true,
        breakpoints: {
          0: {
            itemsToSlide: 1,
            itemsToShow: 1
          },
          800: {
            itemsToSlide: 1,
            itemsToShow: 3
          },
          1000: {
            itemsToSlide: 1,
            itemsToShow: 3
          }
        }
      },
      room: [],
      journal: [],
      testi: [{
          title: 'Arco D',
          content: `Hotel terworthit di sekitaran gading serpong.. Pelayanan ramah dan bagi yang takut untuk menginap
                Di masa pandemi ini, Qubika hotel adalah hotel yang paling pas untuk menjawab ketakutan tersebut, dikarenakan pelaksanaan protokol kesehatan yang sangat baik, Standar kebersihan yang selalu dijaga, kamar dan lorong yang selalu difogging secara rutin membuat kita worry free untuk menginap di Qubika hotel.`,
          image: require('../assets/images/testi/1.jpg')
        },
        {
          title: 'Sarah',
          content: `Pertama kali nginep ke Qubika dengan konsep penginapan yang unik. Buat foto2 oke bangett. Udah gitu kamarnya bersih dan nyaman. Gak meragukan deh untuk kebersihannya. Apa lagi di saat pandemi begini. Merek juga pake sinar uv untuk bersihin bakter2 di setiap ruangan. Makanan di Portable juga enak2. Harga menentukan kualitas. Gak boong. See youuu Qubika. Entar nginep lagi sama pasanganku.`,
          image: require('../assets/images/testi/2.jpg')
        }
      ],
      hotelInfo: [{
          title: 'Check-in and Check-out Time',
          content: `Check-in: From 14:00<br>Check-out: Before 12:00`
        },
        {
          title: 'Location',
          content: `Qubika Boutique Hotel is located in area / city Serpong. <br>
                  The hotel is located only 7.37 km away from Cisauk Station.<br>
                  There are plenty of tourist attractions nearby, such as Summarecon Digital Center within 0.61 km, and Scientia Square Park (SQP) within 0.66 km.`
        }
      ],
      date: {
        in: null,
        out: null,
      },
      promo: [],
      carousel: [],
      welcome: Object,
      promoShow: []
    };
  },
  methods: {
    limitWord(yourString,maxLength){
      let string = yourString.replace(/<[^>]*>?/gm, '');
      //trim the string to the maximum length
      var trimmedString = string.substr(0, maxLength);

      //re-trim if we are in the middle of a word
      return trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    },
    loadRoom(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'ROOM ITEM',
        sortDir: 'asc',
        sortBy : 'id',
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        data.map((x)=>{
          x.child.map((z)=>{
            if(z.type == 'ROOM ITEM PRICE')
            x.price = z.content
          })
        })
        this.room = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadJournal(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'JOURNAL ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.journal = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadCarousel(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'CAROUSEL ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.carousel = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadWelcome(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'WELCOME ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data[0]
        this.welcome = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadTestimoni(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'TESTI ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.testi = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadHotelInfo(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'HOTEL INFO ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.hotelInfo = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadPromo(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'PROMO ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.promo = data
        this.promo.map((x) => {
          let active = x.child[0].content
          if(active == 'Show'){
            this.promoShow.push(x)
          }
        })
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    thousand(num) {
      if (num) {
        let num_parts = num.toString().split(",");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(",");
      } else {
        return 0
      }
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  },
  mounted(){
    this.loadRoom()
    this.loadJournal()
    this.loadCarousel()
    this.loadWelcome()
    this.loadTestimoni()
    this.loadHotelInfo()
    this.loadPromo()
    console.log(baseUrl)
    this.$root.$on('bv::modal::hide', (res) => {
      let id = res.componentId
      if(id == 'modal-promo'){
        let lastShown = {
          date: new Date(),
          status: 'Shown'
        }
        let shown = localStorage.getItem("qubikaPromo")
        let duration = 0
        if(shown){
          let lastShown = JSON.parse(shown)
          let dateNow = new Date()
          let lastDate = new Date(lastShown.date)
          duration = (dateNow-lastDate) / (1000*3600*24)
        }
        if(duration < 1){
          localStorage.setItem("qubikaPromo", JSON.stringify(lastShown));
        }
      }
    })
  },
  watch: {
    promoShow: {
      handler(val){
        let shown = localStorage.getItem("qubikaPromo")
        let duration = 0
        if(shown){
          let lastShown = JSON.parse(shown)
          let dateNow = new Date()
          let lastDate = new Date(lastShown.date)
          duration = (dateNow-lastDate) / (1000*3600*24)
        }
        if(val.length > 0 && duration > 1){
          this.$bvModal.show('modal-promo')
        }
      },
      deep: true
    }
  }
}
</script>
